module.exports = __webpack_public_path__ + "media/components/terrain-mapping/icons/Tourist Interest-3569950295913c30975d84e4073f3ff6.png";